export enum EventType {
  // navbar
  MODAL_EVENT = 'MODAL:EVENT',
  BACK_EVENT = 'BACK:EVENT',
  UPDATE_LAYOUT = 'UPDATE:LAYOUT',
  CHANGE_VIEW = 'CHANGE:VIEW',
  NAVBAR_ACTION = 'NAVBAR:ACTION',
  REPORT_ACTION = 'REPORT:ACTION',
  NAVBAR_OPEN = 'NAVBAR:OPEN',
  NAVBAR_CLOSE = 'NAVBAR:CLOSE',
  SESSION_UPDATE = 'SESSION:UPDATE',
  USER_UPDATE = 'USER:UPDATE',
  PROFILE_UPDATE = 'PROFILE:UPDATE',
  CONFIG_UPDATE = 'CONFIG:UPDATE',
}
